// extracted by mini-css-extract-plugin
export default {"wrapper":"EditMember_wrapper__+8BLL","header":"EditMember_header__2I+kF"};